import { CustomImage, IconCircle, TableData } from "@veneer/core";
import {
  IMetricSosWebDto,
  IMetricsCheckInWebDto,
  IMetricsTrainingMaterialWebDto,
  IMetricVisualPcWebDto,
  IMetricAbsenceWebDto,
  IMetricSyncWebDto,
  IMetricsVisualStatusWebDto,
  IMetricByAdvisorWebDto,
  IGetMetricByPosWebDto,
  IMetricAbsenceCheckInWebDto,
} from "../../../models/dto/surveyApi/IMetricsDto";
import { Dispatch, SetStateAction } from "react";
import IconUserNotFound from "../../../assets/img/attendance/VectoruserNotFound.png";

type MetricData =
  | IMetricSosWebDto
  | IMetricsCheckInWebDto
  | IMetricsTrainingMaterialWebDto
  | IMetricVisualPcWebDto
  | IMetricAbsenceWebDto
  | IMetricSyncWebDto
  | IMetricsVisualStatusWebDto
  | IMetricByAdvisorWebDto
  | IGetMetricByPosWebDto
  | IMetricAbsenceCheckInWebDto;

export default interface ITableColumnMapping {
  [key: string]: string;
}

const formatPercentage = (value: number) => {
  return `${value}%`;
};

const fillDataGeneric = (
  data: MetricData[],
  setTable: Dispatch<SetStateAction<TableData[]>>,
  setLoading: Dispatch<SetStateAction<boolean>>,
  columnMapping?: ITableColumnMapping
): void => {
  if (columnMapping) {
    const tableData: TableData[] = data.map((item) => {
      const row: any = {};
      for (const [key, value] of Object.entries(columnMapping)) {
        if (key === "date" && item[value as keyof MetricData]) {
          row[key] = new Date(item[value as keyof MetricData])
            .toISOString()
            .split("T")[0];
        } else {
          row[key] = item[value as keyof MetricData];
        }
      }
      row.rowConfig = {
        disabled: false,
        noWrap: false,
        selected: false,
      };
      return row;
    });
    console.log("tableData", tableData);
    
    setTable(tableData);
    setLoading(false);
  }
};

const fillDataMetricByPos = (
  data: IGetMetricByPosWebDto[],
  setTable: Dispatch<SetStateAction<TableData[]>>,
  setLoading: Dispatch<SetStateAction<boolean>>
): void => {
  const tableData: TableData[] = data.map((metricByPos) => {
    return {
      date: new Date(metricByPos.date).toISOString().split("T")[0],
      supervisor: metricByPos.supervisorName,
      total_pos: metricByPos.totalPos,

      share_of_shelf_print:
        metricByPos.sosPrint < 70 ? (
          <div className="percentageAndIcon">
            <p>{formatPercentage(metricByPos.sosPrint)}</p>
            <IconCircle filled color="colorRed4" size={25} />
          </div>
        ) : metricByPos.sosPrint >= 70 && metricByPos.sosPrint < 80 ? (
          <div className="percentageAndIcon">
            <p>{formatPercentage(metricByPos.sosPrint)}</p>
            <IconCircle filled color="colorYellow4" size={25} />
          </div>
        ) : (
          <div className="percentageAndIcon">
            <p>{formatPercentage(metricByPos.sosPrint)}</p>
            <IconCircle filled color="colorGreen4" size={25} />
          </div>
        ),

      share_of_shelf_pc:
        metricByPos.sosPc < 70 ? (
          <div className="percentageAndIcon">
            <p>{formatPercentage(metricByPos.sosPc)}</p>
            <IconCircle filled color="colorRed4" size={25} />
          </div>
        ) : metricByPos.sosPc >= 70 && metricByPos.sosPc < 80 ? (
          <div className="percentageAndIcon">
            <p>{formatPercentage(metricByPos.sosPc)}</p>
            <IconCircle filled color="colorYellow4" size={25} />
          </div>
        ) : (
          <div className="percentageAndIcon">
            <p>{formatPercentage(metricByPos.sosPc)}</p>
            <IconCircle filled color="colorGreen4" size={25} />
          </div>
        ),

      competitor_advisors:
        metricByPos.esfCoverage < 70 ? (
          <div className="percentageAndIcon">
            <p>{formatPercentage(metricByPos.esfCoverage)}</p>
            <IconCircle filled color="colorRed4" size={25} />
          </div>
        ) : metricByPos.esfCoverage >= 70 && metricByPos.esfCoverage < 80 ? (
          <div className="percentageAndIcon">
            <p>{formatPercentage(metricByPos.esfCoverage)}</p>
            <IconCircle filled color="colorYellow4" size={25} />
          </div>
        ) : (
          <div className="percentageAndIcon">
            <p>{formatPercentage(metricByPos.esfCoverage)}</p>
            <IconCircle filled color="colorGreen4" size={25} />
          </div>
        ),

      visual_execution_print:
        metricByPos.visualExecutionPrint < 60 ? (
          <div className="percentageAndIcon">
            <p>{formatPercentage(metricByPos.visualExecutionPrint)}</p>
            <IconCircle filled color="colorRed4" size={25} />
          </div>
        ) : metricByPos.visualExecutionPrint >= 60 &&
          metricByPos.visualExecutionPrint < 80 ? (
          <div className="percentageAndIcon">
            <p>{formatPercentage(metricByPos.visualExecutionPrint)}</p>
            <IconCircle filled color="colorYellow4" size={25} />
          </div>
        ) : (
          <div className="percentageAndIcon">
            <p>{formatPercentage(metricByPos.visualExecutionPrint)}</p>
            <IconCircle filled color="colorGreen4" size={25} />
          </div>
        ),

      visual_execution_pc:
        metricByPos.visualExecutionPc < 60 ? (
          <div className="percentageAndIcon">
            <p>{formatPercentage(metricByPos.visualExecutionPc)}</p>
            <IconCircle filled color="colorRed4" size={25} />
          </div>
        ) : metricByPos.visualExecutionPc >= 60 &&
          metricByPos.visualExecutionPc < 80 ? (
          <div className="percentageAndIcon">
            <p>{formatPercentage(metricByPos.visualExecutionPc)}</p>
            <IconCircle filled color="colorYellow4" size={25} />
          </div>
        ) : (
          <div className="percentageAndIcon">
            <p>{formatPercentage(metricByPos.visualExecutionPc)}</p>
            <IconCircle filled color="colorGreen4" size={25} />
          </div>
        ),

      totalRecords: metricByPos.totalRegistros,
      rowConfig: {
        disabled: false,
        noWrap: false,
        selected: false,
      },
    };
  });
  setTable(tableData);
  setLoading(false);
};

const fillDataMetricSync = (
  data: IMetricSyncWebDto[],
  setTable: Dispatch<SetStateAction<TableData[]>>,
  setLoading: Dispatch<SetStateAction<boolean>>
): void => {
  const tableData: TableData[] = data.map((metricByPos) => {
    return {
      date: new Date(metricByPos.date).toISOString().split("T")[0],
      supervisor: metricByPos.supervisor,
      promoter: metricByPos.promotor,
      synchronized_days: metricByPos.dias_Sincronizados,
      worked_days: metricByPos.dias_Laborales,
      percentage: formatPercentage(metricByPos.porcentaje),
      status: metricByPos.status,
      totalRecords: metricByPos.totalRegistros,
      rowConfig: {
        disabled: false,
        noWrap: false,
        selected: false,
      },
    };
  });
  setTable(tableData);
  setLoading(false);
};

const fillDataMetricTraining = (
  data: IMetricsTrainingMaterialWebDto[],
  setTable: Dispatch<SetStateAction<TableData[]>>,
  setLoading: Dispatch<SetStateAction<boolean>>
): void => {
  const tableData: TableData[] = data.map((metricByPos) => {
    return {
      date: new Date(metricByPos.date).toISOString().split("T")[0],
      supervisor: metricByPos.supervisor,
      promoter: metricByPos.promotor,
      quantity_Training: metricByPos.cantidad_De_Material_De_Entrenamiento,
      worked_days: metricByPos.dias_Laborales,
      absences: metricByPos.ausencias,
      percentage: formatPercentage(metricByPos.porcentaje),
      status: metricByPos.status,
      totalRecords: metricByPos.totalRegistros,
      rowConfig: {
        disabled: false,
        noWrap: false,
        selected: false,
      },
    };
  });
  setTable(tableData);
  setLoading(false);
};

const fillDataMetricByAdvisor = (
  data: IMetricByAdvisorWebDto[],
  setTable: Dispatch<SetStateAction<TableData[]>>,
  setLoading: Dispatch<SetStateAction<boolean>>
): void => {
  const tableData: TableData[] = data.map((metricByAdvisor) => {
    return {
      date: new Date(metricByAdvisor.date).toISOString().split("T")[0],
      supervisor: metricByAdvisor.supervisorName,
      total_esf: metricByAdvisor.totalEsf,

      synchronization:
        metricByAdvisor.sync === null ? (
          <div className="percentageAndIcon">
            <p>{formatPercentage(metricByAdvisor.sync)}</p>
            <IconCircle filled color="colorRed4" size={25} />
          </div>
        ) : metricByAdvisor.sync < 70 ? (
          <div className="percentageAndIcon">
            <p>{formatPercentage(metricByAdvisor.sync)}</p>
            <IconCircle filled color="colorRed4" size={25} />
          </div>
        ) : metricByAdvisor.sync >= 70 && metricByAdvisor.sync < 90 ? (
          <div className="percentageAndIcon">
            <p>{formatPercentage(metricByAdvisor.sync)}</p>
            <IconCircle filled color="colorYellow4" size={25} />
          </div>
        ) : (
          <div className="percentageAndIcon">
            <p>{formatPercentage(metricByAdvisor.sync)}</p>
            <IconCircle filled color="colorGreen4" size={25} />
          </div>
        ),

      check_in_late:
        metricByAdvisor.checkInLate === null ||
        metricByAdvisor.checkInLate >= 10 ? (
          <div className="percentageAndIcon">
            <p>{formatPercentage(metricByAdvisor.checkInLate)}</p>
            <IconCircle filled color="colorRed4" size={25} />
          </div>
        ) : metricByAdvisor.checkInLate > 0 &&
          metricByAdvisor.checkInLate <= 10 ? (
          <div className="percentageAndIcon">
            <p>{formatPercentage(metricByAdvisor.checkInLate)}</p>
            <IconCircle filled color="colorYellow4" size={25} />
          </div>
        ) : (
          <div className="percentageAndIcon">
            <p>{formatPercentage(metricByAdvisor.checkInLate)}</p>
            <IconCircle filled color="colorGreen4" size={25} />
          </div>
        ),

      training_material:
        metricByAdvisor.trainingMaterial === null ||
        metricByAdvisor.trainingMaterial < 70 ? (
          <div className="percentageAndIcon">
            <p>{formatPercentage(metricByAdvisor.trainingMaterial)}</p>
            <IconCircle filled color="colorRed4" size={25} />
          </div>
        ) : metricByAdvisor.trainingMaterial >= 70 &&
          metricByAdvisor.trainingMaterial < 90 ? (
          <div className="percentageAndIcon">
            <p>{formatPercentage(metricByAdvisor.trainingMaterial)}</p>
            <IconCircle filled color="colorYellow4" size={25} />
          </div>
        ) : (
          <div className="percentageAndIcon">
            <p>{formatPercentage(metricByAdvisor.trainingMaterial)}</p>
            <IconCircle filled color="colorGreen4" size={25} />
          </div>
        ),

        absenceScheduling:
        metricByAdvisor.absenceScheduling > 40 ? (
          <div className="percentageAndIcon">
            <p>{formatPercentage(metricByAdvisor.absenceScheduling)}</p>
            <IconCircle filled color="colorRed4" size={25} />
          </div>
        ) : metricByAdvisor.absenceScheduling > 20 && metricByAdvisor.absenceScheduling <= 40 ? (
          <div className="percentageAndIcon">
            <p>{formatPercentage(metricByAdvisor.absenceScheduling)}</p>
            <IconCircle filled color="colorYellow4" size={25} />
          </div>
        ) : (
          <div className="percentageAndIcon">
            <p>{formatPercentage(metricByAdvisor.absenceScheduling)}</p>
            <IconCircle filled color="colorGreen4" size={25} />
          </div>
        ),

        absences:
        metricByAdvisor.absence < 70 ? (
          <div className="percentageAndIcon">
            <p>{formatPercentage(metricByAdvisor.absence)}</p>
            <IconCircle filled color="colorRed4" size={25} />
          </div>
        ) : metricByAdvisor.absence >= 70 && metricByAdvisor.absence < 90 ? (
          <div className="percentageAndIcon">
            <p>{formatPercentage(metricByAdvisor.absence)}</p>
            <IconCircle filled color="colorYellow4" size={25} />
          </div>
        ) : (
          <div className="percentageAndIcon">
            <p>{formatPercentage(metricByAdvisor.absence)}</p>
            <IconCircle filled color="colorGreen4" size={25} />
          </div>
        ),
        
      totalRecords: metricByAdvisor.totalRegistros,
      rowConfig: {
        disabled: false,
        noWrap: false,
        selected: false,
      },
    };
  });
  setTable(tableData);
  setLoading(false);
};

const fillDataMetricCheckIn = (
  data: IMetricsCheckInWebDto[],
  setTable: Dispatch<SetStateAction<TableData[]>>,
  setLoading: Dispatch<SetStateAction<boolean>>
): void => {
  const tableData: TableData[] = data.map((metricCheckIn) => {
    return {
      date: new Date(metricCheckIn.date).toISOString().split("T")[0],
      supervisor: metricCheckIn.supervisor,
      promoter: metricCheckIn.promotor,
      scheduled_check_in: metricCheckIn.checkIn_Programado,
      registration_date: metricCheckIn.fecha_De_Registro,
      difference_in_minutes: metricCheckIn.diferencia_En_Minutos,
      posCode: metricCheckIn.posCode,
      pointOfSale: metricCheckIn.punto_De_Venta,
      status: metricCheckIn.status,
      photo:
        metricCheckIn.photo === "" ? (
          <div className="DivIconCustomNoItemsAttendance">
            <CustomImage size={55} quietArea={10} src={IconUserNotFound} />
          </div>
        ) : (
          <CustomImage size={100} quietArea={0} src={metricCheckIn.photo} />
        ),
      totalRecords: metricCheckIn.totalRegistros,
      rowConfig: {
        disabled: false,
        noWrap: false,
        selected: false,
      },
    };
  });
  setTable(tableData);
  setLoading(false);
};

export {
  fillDataGeneric,
  fillDataMetricByPos,
  fillDataMetricByAdvisor,
  fillDataMetricSync,
  fillDataMetricTraining,
  fillDataMetricCheckIn,
};
